<template>
  <v-app>
    <div class="container">

      <header-simple></header-simple>

      <div class="contents" v-if="is_confirmed">
        <div class="header-title">
          {{ $t('email_confirm.email_confirm_title' )}}
        </div>
        <div class="actions">
          <router-link tag="div" class="btn"
            :to="{name: 'lab'}">
            <v-btn block depressed color="primary">
              {{ $t('email_confirm.go_to_lab' )}}
            </v-btn>
          </router-link>
        </div>
      </div>

      <div class="contents" v-if="is_expired">
        <div class="header-title">
          {{ $t('email_confirm.not_valid_token' )}}
        </div>
        <div class="header-sub-title">
          {{ $t('email_confirm.resend_email' )}}
        </div>
        <div class="actions">
          <router-link tag="div" class="btn"
            :to="{name: 'account'}">
            <v-btn block depressed color="primary">
              {{ $t('email_confirm.go_to_account' )}}
            </v-btn>
          </router-link>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Email Confirm"
    }
  },

  data() {
    return {
      is_confirmed: false,
      is_expired: false,
    }
  },

  computed: {
    token() {
      return this.$route.query.token
    },
  },

  async created() {
    let token = this.$route.query.token
    try {
      await this.$store.dispatch('confirm/confirmEmail', {
        token: token
      })
    } catch(e) { this.is_expired = true }
    finally {
      if (!this.is_expired) {
        this.is_confirmed = true
      }
    }
  },
}
</script>

<style scoped>

  .container {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contents {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    max-width: 450px;
    width: 100%;
    border: 1px solid #dadce0;
    border-radius: 8px;
    padding: 22px 40px 38px;
    margin-top: 120px;
  }

  .header-title {
    padding: 20px 0;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
  }

  .header-sub-title {
    padding-bottom: 20px;
    text-align: center;
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/common/EmailConfirm.vue